import { render, staticRenderFns } from "./ProfileDeleted.vue?vue&type=template&id=4a6f062a&scoped=true"
import script from "./ProfileDeleted.vue?vue&type=script&lang=js"
export * from "./ProfileDeleted.vue?vue&type=script&lang=js"
import style0 from "./ProfileDeleted.vue?vue&type=style&index=0&id=4a6f062a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6f062a",
  null
  
)

export default component.exports